import { createMuiTheme } from '@material-ui/core/styles';


const arencoPantone = {
    darkBlue: "#052443",
    mediumBlue: "#003152",
    lightBlue: "#0e4b6c",
    green: '#b1ded3',
    gray: '#ECF1F4',
}

export default createMuiTheme({
    palette: {
        arenco: {
            darkBlue: arencoPantone.darkBlue,
            mediumBlue: arencoPantone.mediumBlue,
            lightBlue: arencoPantone.lightBlue,
            green: arencoPantone.green,

        },
        primary: {
            main: arencoPantone.lightBlue,
        },

        secondary: {
            main: arencoPantone.green,
        },

        red: {
            main: '#b71c1c'
        },

        gray: {
            main: arencoPantone.gray,
        }
    },


    overrides: {
        MuiTypography: {
            h1: {
                fontSize: '5rem',

                fontWeight: 700,
            },
            h2: {
                fontSize: '4rem',

                fontWeight: 600,

            },
            h3: {
                fontSize: '3rem',
                fontWeight: 600
            },

            h4: {
                fontSize: '2rem',

                fontWeight: 700,
            },


            body: {
                fontSize: '1rem',

                fontWeight: 200,
                color: arencoPantone.darkBlue
            },
            tab: {

                textTransform: 'none',
                fontWeight: '700',
                fontSize: '1rem',
            }

        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: true
        },
        MuiIconButton: {
            disableRipple: true,
            disableFocusRipple: true,
        },
    },
    styles: {
        iconButtons: {

            "&:hover": {
                backgroundColor: "transparent"
            }

        }
    }


});